import { SleipModalOverlayConfig } from '@shared/models/modal-config.model';

export const SLEIP_MODAL_DEFAULT_CONFIG: SleipModalOverlayConfig = {
  height: 'auto',
  width: 'auto',
  enableClickOutSideDismiss: false,
  hasBackdrop: true,
  backdropClass: 'sleip-modal-overlay-backdrop',
  panelClass: 'sleip-modal-overlay-panel',
};
